module.exports = __webpack_public_path__ + "static/media/reachedTournamentTop10_100_250.69738e1a.png";